module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$root.dataReady) ? _c('div', {
    staticClass: "home"
  }, [
    [_vm._l((_vm.blocks), function(block, index) {
      return [_c(block.acf_fc_layout, {
        key: index,
        tag: "component",
        attrs: {
          "blockdata": block
        }
      })]
    })]
  ], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd60c89e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 371
// module chunks = 0